import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getUserListings, deleteListing } from '../services/listingService';
import ListingCard from '../components/ListingCard';
import '../styles/Listings.css';

const MyListings = () => {
    const [listings, setListings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { user } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!user) {
            navigate('/login');
            return;
        }

        const fetchListings = async () => {
            try {
                const data = await getUserListings();
                setListings(data);
                setLoading(false);
            } catch (err) {
                setError('Failed to load your listings');
                setLoading(false);
            }
        };

        fetchListings();
    }, [user, navigate]);

    const handleDelete = async (id) => {
        try {
            await deleteListing(id);
            setListings(listings.filter(listing => listing.id !== id));
        } catch (err) {
            setError('Failed to delete listing');
        }
    };

    if (!user) {
        return null;
    }

    if (loading) {
        return (
            <div className="listings-container">
                <div className="loading">Loading your listings...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="listings-container">
                <div className="error">{error}</div>
            </div>
        );
    }

    return (
        <div className="listings-container">
            <div className="listings-header">
                <h1>My Listings</h1>
                <Link to="/listings/create" className="create-btn">
                    Create New Listing
                </Link>
            </div>
            {listings.length === 0 ? (
                <div className="empty-state">
                    <p>You haven't created any listings yet.</p>
                    <Link to="/listings/create" className="create-btn">
                        Create Your First Listing
                    </Link>
                </div>
            ) : (
                <div className="listings-grid">
                    {listings.map(listing => (
                        <ListingCard 
                            key={listing.id} 
                            listing={listing}
                            onDelete={handleDelete}
                            isOwner={true}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default MyListings; 